module.exports = __webpack_public_path__ + "img/stream.d4db70fc.png";